export enum EStudyOrderViews {
    NEWSTUDYORDER = 10,
    STUDYORDERHISTORY = 11,
    STUDYORDERAGENDA = 12,
    CREATEPATIENTVIEW = 13,
    PATIENTAGENDA = 14,
    SENDSTUDYORDERVIEW = 15
}

export enum EStudyOrderSteps {
    PATIENTSTEP = 0,
    PRESCRIPTIONSTEP = 1,
    CONFIRMATIONSTEP = 2,
}